import React from 'react';

const LongReadContext = React.createContext(null);

export default LongReadContext;
